import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotAlarm, UpdateSnapshotAlarmDto } from 'types';
import { convertAlarm } from 'api/dtoConverters';

export const updateAlarm = async ({
  data,
  alarmId,
}: {
  data: UpdateSnapshotAlarmDto;
  alarmId: number;
}): Promise<SnapshotAlarm> => {
  const response = await axios.put(
    `/api/snapshots/alarms/${alarmId}`,
    convertAlarm(data)
  );
  return response.data as SnapshotAlarm;
};

type UseUpdateSnapshotAlarmsOptions = {
  config?: MutationConfig<typeof updateAlarm>;
};

export const useUpdateAlarm = ({
  config,
}: UseUpdateSnapshotAlarmsOptions = {}) => {
  return useMutation({
    onMutate: async (updatingAlarm) => {
      await queryClient.cancelQueries(['alarms', updatingAlarm?.alarmId]);

      const previousAlarm = queryClient.getQueryData<SnapshotAlarm>([
        'alarms',
        updatingAlarm?.alarmId,
      ]);

      queryClient.setQueryData(['alarms', updatingAlarm?.alarmId], {
        ...previousAlarm,
        ...updatingAlarm.data,
        id: updatingAlarm.alarmId,
      });

      return { previousAlarm };
    },
    onError: (_, __, context: any) => {
      if (context?.previousAlarm) {
        queryClient.setQueryData(
          ['alarms', context.previousAlarm.id],
          context.previousAlarms
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['alarms']);
    },
    ...config,
    mutationFn: updateAlarm,
  });
};
